import { AlertBanner } from '@/contasis/components/AlertBanner';
import { useWorkspace } from '@/contexts/ContextoWorkspace';
import { esEmpresaDemo } from '@/shared/demo';

interface DemoBannerProps {
  onRegistrar?: () => void;
}

export const DemoBanner = ({ onRegistrar }: DemoBannerProps) => {
  const { currentEmpresa } = useWorkspace();

  if (!esEmpresaDemo(currentEmpresa?.ruc)) return null;

  return (
    <AlertBanner variant="info" ctaLabel="Elegir un plan" onCta={onRegistrar}>
      <strong style={{ fontWeight: 600 }}>Estás en modo demo</strong>
      <span style={{ fontWeight: 500 }}> · Puedes probar todo sin problema. Cuando estés listo, elige un plan y empieza a gestionar tu negocio con Senciyo.</span>
    </AlertBanner>
  );
};
